const mediaProviderTypes = {};

mediaProviderTypes.UNSPLASH = 'UNSPLASH';
mediaProviderTypes.GIPHY = 'GIPHY';

export default mediaProviderTypes;